import React, { useMemo } from 'react';
import { CellProps } from 'react-table';
import moment from 'moment/moment';

import { useI18n } from 'i18n';
import { ITepOfficersNotification } from 'types/tep';

export const useClientsNotificationsColumns = () => {
  const { fc } = useI18n();

  const getDateCell = ({ cell }: CellProps<ITepOfficersNotification>) => (
    <>{cell.value ? moment(cell.value).format('YYYY-MM-DD, HH:mm:ss') : '-'}</>
  );

  return useMemo(
    () => [
      { Header: fc('company'), accessor: 'lease.company' },
      { Header: fc('email'), accessor: 'lease.email' },
      { Header: fc('message'), accessor: 'message', width: 300, minWidth: 300 },
      { Header: fc('Sent At'), accessor: 'createdAt', Cell: getDateCell, width: 250, minWidth: 250, isFlexUnset: true },
    ],
    [],
  );
};
